import config from '../../config';
import store from '../store';
import APIService from './APIService';

// Example for archiveId -
export default class ArchiveService extends APIService {
  /**
   * To mark a email as spam
   * @param {String} archiveId
   */
  static markAsSpam(archives) {
    let orgId = store.state.currentlySelectedOrgId
      ? store.state.currentlySelectedOrgId
      : store.state.orgId;

    return this.post(`${config.baseUrlForMailSync}/archives/spam`, {
      archives,
      currentOrg: orgId,
      spam: true
    });
  }
  /**
   * To mark a email as legitimate
   *
   * @param {string} archiveId
   */
  static markAsInbox(archives) {
    let orgId = store.state.currentlySelectedOrgId
      ? store.state.currentlySelectedOrgId
      : store.state.orgId;

    return this.post(`${config.baseUrlForMailSync}/archives/spam`, {
      archives,
      currentOrg: orgId,
      spam: false
    });
  }

  /**
   * To redeliver to a email
   *
   * @param {*} archiveId
   * @param {*} receipients
   */
  static reDeliver(archives) {
    let orgId = store.state.currentlySelectedOrgId
      ? store.state.currentlySelectedOrgId
      : store.state.orgId;

    return this.post(`${config.baseUrlForMailSync}/archives/redeliver`, {
      archives,
      currentOrg: orgId
    });
  }
}
